import * as React from 'react'

import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { useMediaQuery } from 'react-responsive'

import * as tokens from '@cash-design-system/tokens'

import Logo, { ColorVariants, LogoVariants } from './Logo'

export type GlobalHeaderProps = {
  children?: React.ReactNode
  colorVariant?: ColorVariants
  logoVariant?: LogoVariants
  showCompanyName?: boolean
  unsetBackgroundAndBorder?: boolean
}

const tabletMediaQuery = `(min-width: ${tokens.BreakpointSmall})`

const Container = styled.header<{ unsetBackgroundAndBorder: boolean }>`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  height: 4rem;

  background: ${props => (props.unsetBackgroundAndBorder ? 'unset' : props.theme.colors.cardBackground)};
  border-bottom: 1px solid ${props => (props.unsetBackgroundAndBorder ? 'none' : props.theme.colors.hairline)};
  ${({ theme }) => theme.breakpoints.tablet} {
    border-bottom: none;
    background: unset;
  }
  svg {
    margin: 0 1.5rem;
  }
`

const Actions = styled.div`
  text-align: right;
`

const GlobalHeader: React.FC<GlobalHeaderProps> = ({
  colorVariant,
  logoVariant = 'default',
  showCompanyName,
  unsetBackgroundAndBorder = false,
  children,
}) => {
  const isTabletOrDesktop = useMediaQuery({ query: tabletMediaQuery })
  const withText = showCompanyName || isTabletOrDesktop
  const theme = useTheme()

  // Use white for the default color in dark mode
  const defaultColorVariant = theme.darkMode ? 'white' : 'default'

  const logoColorVariant = colorVariant && colorVariant !== 'default' ? colorVariant : defaultColorVariant

  return (
    <Container unsetBackgroundAndBorder={unsetBackgroundAndBorder}>
      <Logo withText={withText} colorVariant={logoColorVariant} variant={logoVariant} altText="Cash App" />
      <Actions>{children}</Actions>
    </Container>
  )
}

export default GlobalHeader
